import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import { ListItemIcon, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import KeyIcon from '@mui/icons-material/Key';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import { notifyPermissionsChanged } from '../../permission/PermissionUtil';

const UserMenu = ({ isVisible, user, onHide, setIsChangePasswordVisible, showAbout, setIsUserDetailsVisible }) => {
    const navigate = useNavigate();

    const onUserClick = () => {
        onHide();
        setIsUserDetailsVisible(true);
    };

    const onChangePasswordClick = () => {
        onHide();
        setIsChangePasswordVisible(true);
    };

    const onShowAboutClick = () => {
        onHide();
        showAbout();
    };

    const handleLogout = async () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('displayName');
        localStorage.removeItem('permissions');
        localStorage.removeItem('administrator');
        localStorage.removeItem('user');
        notifyPermissionsChanged();
        await axios.get('/login/logout');
        navigate('/login');
    };

    return (
        <Menu
            id="user-menu"
            sx={{ top: '32px', left: '20px' }}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isVisible}
            onClose={onHide}
        >
            <MenuItem onClick={onUserClick}>
                <ListItemIcon>
                    <PersonIcon fontSize="small" />
                </ListItemIcon>
                <Typography>{user?.displayName}</Typography>
            </MenuItem>
            <MenuItem onClick={onChangePasswordClick}>
                <ListItemIcon>
                    <KeyIcon fontSize="small" />
                </ListItemIcon>
                Change Password
            </MenuItem>
            <MenuItem onClick={onShowAboutClick}>
                <ListItemIcon>
                    <InfoIcon fontSize="small" />
                </ListItemIcon>
                About
            </MenuItem>
            <MenuItem onClick={handleLogout}>
                <ListItemIcon>
                    <LogoutIcon fontSize="small" />
                </ListItemIcon>
                Logout
            </MenuItem>
        </Menu>
    );
};

export default UserMenu;
